import { RecordActions } from './actions'
import { RecordGetters } from './getters'
import { RecordMutations } from './mutations'
import { RecordState } from './state'

export { virginRecord } from './state'

export const RECORD_NAMESPACE = 'record'

export const Record = {
  actions: RecordActions,
  getters: RecordGetters,
  mutations: RecordMutations,
  namespaced: true,
  state: RecordState,
}
